import React from 'react'
import Form from './components/Form'
import ExtensionService from 'live/services/extension'
import { LiveApi } from 'live/lib/api'
import { HomePage } from './components/HomePage'
import { homeType } from './utils/constants'
import { RouteApi } from './api/RouteApi'

import './components/NavbarRegister'

const routeApi = new RouteApi()

async function init(): Promise<void> {
    try {
        document.addEventListener('DOMContentLoaded', async function () {
            require('./init.js')
        })

        const extensionInstances = await routeApi.getAll()

        if (extensionInstances.length) {
            for (const values of extensionInstances) {
                const [[extensionUuid, fields]] = Object.entries(values)

                const Wrapper = (): JSX.Element => (
                    <HomePage
                        uuid={extensionUuid}
                        pageType={fields.pageType}
                        pageName={fields.pageName}
                        routes={fields.routes}
                    />
                )

                LiveApi.HomePages.register({
                    key: fields.pageType,
                    label: fields.pageName,
                    existsOnMenu: false,
                    Page: Wrapper
                })
            }
        }

        const homepage = {
            name: 'Home Page',
            type: homeType,
            origin: 'Plugin Smart Mobility Home Page',
            icon: '/content/plugin-smart-mobility-home-page/homepage-icon.png',
            ui: {
                form: Form,
                view: null
            }
        }

        ExtensionService.register(homepage)
    } catch (e) {
        console.error(e)
    }
}

init()
